var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var AppearanceIcon = function (props) { return (_jsxs("svg", __assign({ width: '24', height: '24', viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2' }, props, { children: [_jsx("circle", { cx: '12', cy: '12', r: '3' }), _jsx("path", { d: 'M12 5V3m0 18v-2m7-7h2M3 12h2m12.5-5.5l1.5-1.5M5 5l1.5 1.5m11 11l1.5 1.5M5 19l1.5-1.5' })] }))); };
